<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Ibas User List
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" @click="addIbasUser()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.name`]="{ item }">
        <a @click="viewDrawDetail(item)">{{ item.name }}</a>
      </template> -->

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <!-- <template v-slot:[`item.amountPaid`]="{ item }">
        {{ item.amountPaid.toLocaleString() }}
      </template> -->

            <!-- <template v-slot:[`item.actions`]="{ item }">
        <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
          Edit</v-btn
        >
      </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- <AddIbasUserDialog
      :dialog="addIbasUserDialog.dialog"
      @close="addIbasUserDialog.dialog = !addIbasUserDialog.dialog"
      @response="addSalesAgentResponse"
    ></AddIbasUserDialog> -->
    <AddIbasUserDialog ref="addIbasUserDialog" />
  </v-container>
</template>

<script>
// import moment from "moment";
import AddIbasUserDialog from "../dialogs/dealer/AddIbasUserDialogv2.vue";
export default {
  name: "SalesAgent",
  components: {
    AddIbasUserDialog,
  },
  data() {
    return {
      addIbasUserDialog: {
        dialog: false,
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          // {
          //   text: "Date",
          //   align: "start",
          //   sortable: false,
          //   value: "createdDate",
          //   formatter: (x) => (x ? moment(x).format("MMMM DD, YYYY") : null),
          // },
          {
            text: "Name",
            align: "start",
            value: "name",
          },

          {
            text: "Sign-up (not paid)",
            align: "center",
            value: "registered",
            sortable: false,
          },
          {
            text: "Sign-up (paid)",
            align: "center",
            value: "paid",
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=sales-agent")
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    viewDrawDetail(data) {
      this.$store.dispatch("addDrawDetails", data);
      this.$router
        .push({ path: `${this.$route.matched[0].path}/draw/view/${data.id}` })
        .catch(() => {});
    },

    async addIbasUser() {
      await this.$refs.addIbasUserDialog.open().then((result) => {
        if (result) {
          this.getList();
        }
      });
    },

    addSalesAgentResponse(res) {
      if (res) {
        this.getList();
        this.addSaleAgent.dialog = false;
      }
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
